import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/store";
import { useGetModulesQuery } from "src/store/slices/client/client.api";
import { setMenuItems } from "src/store/slices/client/client.slice";
import { persistedModules } from "src/store/persistedClientData";

export default function useGetModules({ skip = false }: { skip?: boolean } = {}) {
  const token = useSelector((state: RootState) => state.auth.token);
  const [hasCachedModules] = useState(() => !!persistedModules.read());
  const { data: modules, isFetching , error} = useGetModulesQuery(token, { skip: skip || !token || hasCachedModules });
  const dispatch = useDispatch();
  useEffect(() => {
    if (modules) {
      dispatch(setMenuItems(modules));
    }
  }, [modules]);
  return { isFetching, modules, error };
}
